import {
  Typography,
  FormControl,
  Container,
  Input,
  Button,
} from "@mui/material";
import { useState } from "react";

import {
  collection,
  getDocs,
  query,
  where,
  addDoc,
  updateDoc,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";

import { db } from "../firebase.config";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

function CreateGenre() {
  const auth = getAuth();
  const [formData, setFormData] = useState({
    name: "",
    key: "",
    topicsRef: "",
  });

  const navigate = useNavigate();

  const createGenre = async () => {
    try {
      // Get topics
      // Get Reference
      const genreRef = collection(db, "formGenres");

      // Execute query
      const q = query(genreRef, where("name", "==", formData.name));

      const tierListGenreSnap = await getDocs(q);
      console.log("tierListGenreSnap :", tierListGenreSnap);
      if (!tierListGenreSnap.empty) {
        toast.error("Genre already exists!");
        return;
      }
      console.log(tierListGenreSnap);

      const genreDocData = {
        ...formData,
        userRef: auth.currentUser.uid,
      };
      const genreDocRef = await addDoc(
        collection(db, "formGenres"),
        genreDocData
      );
      console.log("genreDocRef.id :", genreDocRef.id);

      const newTopicDocData = {
        name: formData.name,
        key: formData.key,
        options: [],
        genreRef: genreDocRef,
        userRef: auth.currentUser.uid,
      };
      console.log("newTopicDocData :", newTopicDocData);

      const topicDocRef = await addDoc(
        collection(db, "formTopics"),
        newTopicDocData
      );
      console.log("topicDocRef :", topicDocRef);

      const newGenreDocData = {
        ...formData,
        topicsRef: topicDocRef,
        userRef: auth.currentUser.uid,
      };

      await updateDoc(genreDocRef, newGenreDocData);
    } catch (error) {
      console.log(error);
      toast.error("Could not fetch Topics!");
    }
  };

  const onChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.id]: e.target.value,
    }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    console.log("Submitted!");
    createGenre();
    navigate("/tierlist/new");
  };
  return (
    <Container>
      <Typography variant="h1" component="h1">
        Create a new Genre
      </Typography>
      <form onSubmit={onSubmit}>
        <FormControl>
          <label htmlFor="name">Enter name:</label>
          <Input id="name" label="name" onChange={onChange} />
        </FormControl>
        <FormControl>
          <label htmlFor="key">Enter key:</label>
          <Input id="key" label="key" onChange={onChange} />
        </FormControl>
        <FormControl>
          <Button
            type="submit"
            variant="contained"
            sx={{ textTransform: "none" }}
          >
            Make new Genre
          </Button>
        </FormControl>
      </form>
    </Container>
  );
}

export default CreateGenre;
